/** @license WayToBill v3.28.85
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _i18n = _interopRequireDefault(require("./i18n"));

var _package = _interopRequireDefault(require("../package"));

var _browsers = require("./browsers");

var _capitalize = _interopRequireDefault(require("./capitalize"));

var _cleanString = _interopRequireDefault(require("./clean-string"));

var _colors = require("./colors");

var _cookies = require("./cookies");

var _countries = require("./countries");

var _currency = require("./currency");

var _debounce = _interopRequireDefault(require("./debounce"));

var _escapeRegExp = _interopRequireDefault(require("./escapeRegExp"));

var _findCommonStrings = _interopRequireDefault(require("./findCommonStrings"));

var _flatten = _interopRequireDefault(require("./flatten"));

var _getElementPosition = _interopRequireDefault(require("./getElementPosition"));

var _GMapsToWTBAddress = _interopRequireDefault(require("./GMapsToWTBAddress"));

var _invoice = require("./invoice");

var _locale = require("./locale");

var _Logger = _interopRequireDefault(require("./Logger"));

var _request = require("./request");

var _responseParsers = require("./response-parsers");

var _session = require("./session");

var _unflatten = _interopRequireDefault(require("./unflatten"));

var _validation = require("./validation");

var _pdf = require("./pdf");

var _mask = require("./mask");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GMapsToWTBAddress", {
  enumerable: true,
  get: function get() {
    return _GMapsToWTBAddress["default"];
  }
});
Object.defineProperty(exports, "Logger", {
  enumerable: true,
  get: function get() {
    return _Logger["default"];
  }
});
Object.defineProperty(exports, "VALIDATION_EXAMPLES", {
  enumerable: true,
  get: function get() {
    return _validation.EXAMPLES;
  }
});
Object.defineProperty(exports, "VALIDATION_REGEX", {
  enumerable: true,
  get: function get() {
    return _validation.REGEX;
  }
});
Object.defineProperty(exports, "addOpacityToHex", {
  enumerable: true,
  get: function get() {
    return _colors.addOpacityToHex;
  }
});
Object.defineProperty(exports, "capitalize", {
  enumerable: true,
  get: function get() {
    return _capitalize["default"];
  }
});
Object.defineProperty(exports, "cleanCustomerDataToBE", {
  enumerable: true,
  get: function get() {
    return _responseParsers.cleanCustomerDataToBE;
  }
});
Object.defineProperty(exports, "cleanCustomerDataToFE", {
  enumerable: true,
  get: function get() {
    return _responseParsers.cleanCustomerDataToFE;
  }
});
Object.defineProperty(exports, "cleanString", {
  enumerable: true,
  get: function get() {
    return _cleanString["default"];
  }
});
Object.defineProperty(exports, "clearSession", {
  enumerable: true,
  get: function get() {
    return _session.clear;
  }
});
Object.defineProperty(exports, "cookieExists", {
  enumerable: true,
  get: function get() {
    return _cookies.exists;
  }
});
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function get() {
    return _debounce["default"];
  }
});
Object.defineProperty(exports, "downloadInvoicePdf", {
  enumerable: true,
  get: function get() {
    return _pdf.createInvoice;
  }
});
Object.defineProperty(exports, "escapeRegExp", {
  enumerable: true,
  get: function get() {
    return _escapeRegExp["default"];
  }
});
Object.defineProperty(exports, "findCommonStrings", {
  enumerable: true,
  get: function get() {
    return _findCommonStrings["default"];
  }
});
Object.defineProperty(exports, "flatten", {
  enumerable: true,
  get: function get() {
    return _flatten["default"];
  }
});
Object.defineProperty(exports, "get", {
  enumerable: true,
  get: function get() {
    return _request.get;
  }
});
Object.defineProperty(exports, "getAllCookies", {
  enumerable: true,
  get: function get() {
    return _cookies.getAll;
  }
});
Object.defineProperty(exports, "getBaseLocale", {
  enumerable: true,
  get: function get() {
    return _locale.getBaseLocale;
  }
});
Object.defineProperty(exports, "getCookie", {
  enumerable: true,
  get: function get() {
    return _cookies.get;
  }
});
Object.defineProperty(exports, "getCountryCode", {
  enumerable: true,
  get: function get() {
    return _countries.getCode;
  }
});
Object.defineProperty(exports, "getCountryName", {
  enumerable: true,
  get: function get() {
    return _countries.getName;
  }
});
Object.defineProperty(exports, "getCurrencyFormat", {
  enumerable: true,
  get: function get() {
    return _currency.getCurrencyFormat;
  }
});
Object.defineProperty(exports, "getCurrencySymbol", {
  enumerable: true,
  get: function get() {
    return _currency.getCurrencySymbol;
  }
});
Object.defineProperty(exports, "getDateLocale", {
  enumerable: true,
  get: function get() {
    return _locale.getDateLocale;
  }
});
Object.defineProperty(exports, "getElementPosition", {
  enumerable: true,
  get: function get() {
    return _getElementPosition["default"];
  }
});
Object.defineProperty(exports, "getFromSession", {
  enumerable: true,
  get: function get() {
    return _session.get;
  }
});
Object.defineProperty(exports, "getLocaleAmount", {
  enumerable: true,
  get: function get() {
    return _locale.getLocaleAmount;
  }
});
Object.defineProperty(exports, "getLocaleFromLanguageCode", {
  enumerable: true,
  get: function get() {
    return _locale.getLocaleFromLanguageCode;
  }
});
Object.defineProperty(exports, "getLuminance", {
  enumerable: true,
  get: function get() {
    return _colors.getLuminance;
  }
});
Object.defineProperty(exports, "hexToRgb", {
  enumerable: true,
  get: function get() {
    return _colors.hexToRgb;
  }
});
Object.defineProperty(exports, "hexToRgbDecimals", {
  enumerable: true,
  get: function get() {
    return _colors.hexToRgbDecimals;
  }
});
Object.defineProperty(exports, "isBrowser", {
  enumerable: true,
  get: function get() {
    return _browsers.isBrowser;
  }
});
Object.defineProperty(exports, "isDark", {
  enumerable: true,
  get: function get() {
    return _colors.isDark;
  }
});
Object.defineProperty(exports, "isDesktop", {
  enumerable: true,
  get: function get() {
    return _browsers.isDesktop;
  }
});
Object.defineProperty(exports, "isLight", {
  enumerable: true,
  get: function get() {
    return _colors.isLight;
  }
});
Object.defineProperty(exports, "isMobile", {
  enumerable: true,
  get: function get() {
    return _browsers.isMobile;
  }
});
Object.defineProperty(exports, "isNode", {
  enumerable: true,
  get: function get() {
    return _browsers.isNode;
  }
});
Object.defineProperty(exports, "isOrdinalLanguage", {
  enumerable: true,
  get: function get() {
    return _locale.isOrdinalLanguage;
  }
});
Object.defineProperty(exports, "isSafari", {
  enumerable: true,
  get: function get() {
    return _browsers.isSafari;
  }
});
Object.defineProperty(exports, "isValidCountryCode", {
  enumerable: true,
  get: function get() {
    return _countries.isValidCountryCode;
  }
});
Object.defineProperty(exports, "isVariantLocale", {
  enumerable: true,
  get: function get() {
    return _locale.isVariantLocale;
  }
});
Object.defineProperty(exports, "maskBankNumber", {
  enumerable: true,
  get: function get() {
    return _mask.maskBankNumber;
  }
});
Object.defineProperty(exports, "maskPhoneNumber", {
  enumerable: true,
  get: function get() {
    return _mask.maskPhoneNumber;
  }
});
Object.defineProperty(exports, "parseInvoiceDataResponse", {
  enumerable: true,
  get: function get() {
    return _invoice.parseInvoiceDataResponse;
  }
});
Object.defineProperty(exports, "percentageToHex", {
  enumerable: true,
  get: function get() {
    return _colors.percentageToHex;
  }
});
Object.defineProperty(exports, "post", {
  enumerable: true,
  get: function get() {
    return _request.post;
  }
});
Object.defineProperty(exports, "put", {
  enumerable: true,
  get: function get() {
    return _request.put;
  }
});
Object.defineProperty(exports, "registerDefaultLanguages", {
  enumerable: true,
  get: function get() {
    return _countries.registerDefaultLanguages;
  }
});
Object.defineProperty(exports, "registerLanguage", {
  enumerable: true,
  get: function get() {
    return _countries.registerLanguage;
  }
});
Object.defineProperty(exports, "registerLanguages", {
  enumerable: true,
  get: function get() {
    return _countries.registerLanguages;
  }
});
Object.defineProperty(exports, "remove", {
  enumerable: true,
  get: function get() {
    return _request.remove;
  }
});
Object.defineProperty(exports, "removeCookie", {
  enumerable: true,
  get: function get() {
    return _cookies.remove;
  }
});
Object.defineProperty(exports, "removeFromSession", {
  enumerable: true,
  get: function get() {
    return _session.remove;
  }
});
Object.defineProperty(exports, "setCookie", {
  enumerable: true,
  get: function get() {
    return _cookies.set;
  }
});
Object.defineProperty(exports, "setFromSession", {
  enumerable: true,
  get: function get() {
    return _session.set;
  }
});
Object.defineProperty(exports, "setInvalidTokenCallback", {
  enumerable: true,
  get: function get() {
    return _request.setInvalidTokenCallback;
  }
});
Object.defineProperty(exports, "unflatten", {
  enumerable: true,
  get: function get() {
    return _unflatten["default"];
  }
});
Object.defineProperty(exports, "validateCreditCardCode", {
  enumerable: true,
  get: function get() {
    return _validation.validateCreditCardCode;
  }
});
Object.defineProperty(exports, "validateCreditCardDate", {
  enumerable: true,
  get: function get() {
    return _validation.validateCreditCardDate;
  }
});
Object.defineProperty(exports, "validateCreditCardNumber", {
  enumerable: true,
  get: function get() {
    return _validation.validateCreditCardNumber;
  }
});
Object.defineProperty(exports, "validateEmail", {
  enumerable: true,
  get: function get() {
    return _validation.validateEmail;
  }
});
Object.defineProperty(exports, "validateNationalId", {
  enumerable: true,
  get: function get() {
    return _validation.validateNationalId;
  }
});
Object.defineProperty(exports, "validatePassword", {
  enumerable: true,
  get: function get() {
    return _validation.validatePassword;
  }
});
Object.defineProperty(exports, "validatePhone", {
  enumerable: true,
  get: function get() {
    return _validation.validatePhone;
  }
});
exports.version = void 0;

var _i18n = _interopRequireDefault(require("./i18n"));
